import {inject, Injectable} from '@angular/core';
import {Organization} from './organization.types';
import {Meta} from '@angular/platform-browser';

@Injectable({providedIn: 'root'})
export class MetadataService {

  private readonly meta: Meta = inject(Meta);

  loadMetadata(org: Organization): void {
    const url = this.toHttpsUrl(org?.opacUrl);

    // Choose a proper social image - do not use a 192x192 favicon
    const image = 'https://storage.googleapis.com/millonex-assets/logos/simplicity-1200x630-padded.jpg';

    this.setOg('og:type', 'website');
    this.setOg('og:description', 'Browse the catalog to explore books, movies, and more, and easily discover your next great read today.');

    // Either set og:url to the current URL or omit it entirely
    const currentUrl = (globalThis?.document?.location?.href) ?? '';
    this.setOg('og:url', url || currentUrl);

    this.setOg('og:image', image);
    this.setOg('og:image:width', '1200');
    this.setOg('og:image:height', '630');

    this.setOg('og:site_name', 'Simplicity ILS');
  }

  private setOg(property: string, content?: string): void {
    if (!content) return;
    this.meta.updateTag({property, content}, `property='${property}'`);
  }

  private toHttpsUrl(input?: string): string {
    if (!input) return '';

    const u = input.trim();
    if (!u) return '';

    // dev.example.com -> https://dev.example.com
    if (u.startsWith('//')) return `https:${u}`;

    // dev.example.com  -> https://dev.example.com
    if (!/^[a-zA-Z][\w+\-.]*:\/\//.test(u)) return `https://${u}`;

    // http://... -> https://...
    const url = new URL(u);
    if (url.protocol === 'http:') {
      url.protocol = 'https:';
    }
    return url.toString();
  }
}
